import { createApp } from 'vue'
import i18n from './i18n'
import App from './App.vue'
import router from './router'
import store from './store'
import VueGtm from 'vue-gtm'
import '@/api'
import './index.css'
import '@/assets/font/fonts.css'
import '@/assets/main.scss'
import '@/assets/chat.scss'
import '@/assets/main_gept.scss'

import mitt from 'mitt'

import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'

import vClickOutside from "click-outside-vue3"

import '@/components/all.js'

export const app = createApp(App)
app.use(VueGtm, {
	id: 'GTM-KJ6CHMTL',
	vueRouter: router,
	enabled: true,
	debug: false,
})

app.use(i18n)

app.use(VueSweetalert2)

app.use(store).use(router).use(vClickOutside)
const emitter = mitt();
app.config.globalProperties.$emitter = emitter;

app.mount('#app');
